import { Component } from '@angular/core';
import { 
  GitData,
  GitVersion,
  GlobalSessionData,
  GlobalFunctions
} from 'globales-projekt-angular';
import { environment } from 'src/environments/environment';
import { ConstantsTexte } from './immutable/constants-texte';
import { ApiService } from './services/api.service';
import * as gitVersion  from '../git-version.json';
import * as globalGitVersion from '../global-git-version.json';
import { ConstantsSonstige } from './immutable/constants-sonstige';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = ConstantsTexte.ANWENDUNGSNAME;

  constructor(private apiService: ApiService) {
    GlobalSessionData.baseUrl = environment.baseUrl;
    GlobalSessionData.database = environment.baseUrl;

    GlobalSessionData.programname = ConstantsSonstige.PROGRAM_NAME;
    GlobalSessionData.isEntwicklung = ConstantsSonstige.PROGRAM_IS_ENTWICKLUNG;
    GlobalSessionData.database = environment.baseUrl;
    GlobalSessionData.logProgramEbene = ConstantsSonstige.PROGRAM_LOG_PROOGRAM_EBENE;
    GlobalSessionData.version = ConstantsSonstige.PROGRAM_VERSION;
 
    GlobalSessionData.apiService = apiService;
  }

  ngOnInit() {
    

    this.apiService.getGitData().subscribe({


      next: (response: GitData) => {
        let gitVersionVal: GitVersion = new GitVersion();
        let gitVersionVar = gitVersion;
        gitVersionVal.branch = gitVersionVar.branch;
        gitVersionVal.buildTime = gitVersionVar.buildTime;
        gitVersionVal.commitTime = gitVersionVar.commitTime;
        gitVersionVal.commitId = gitVersionVar.commitId;
        gitVersionVal.repository = gitVersionVar.repository;
        
        let globalGitVersionVal: GitVersion = new GitVersion();
        let globalGitVersionVar = globalGitVersion;
        globalGitVersionVal.branch = globalGitVersionVar.branch;
        globalGitVersionVal.buildTime = globalGitVersionVar.buildTime;
        globalGitVersionVal.commitTime = globalGitVersionVar.commitTime;
        globalGitVersionVal.commitId = globalGitVersionVar.commitId;
        globalGitVersionVal.repository = globalGitVersionVar.repository;
 
    GlobalFunctions.printGitData(
          response,
          gitVersionVal,
          globalGitVersionVal,
          ConstantsTexte.ANWENDUNGSNAME
        );
      },
    });
  }
}
